import React from 'react';

const CryptoFeature = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.89268 18.667H5.33268C3.86602 18.667 2.66602 19.867 2.66602 21.3337V28.0003C2.66602 28.7337 3.26602 29.3337 3.99935 29.3337H8.89268C9.62602 29.3337 10.226 28.7337 10.226 28.0003V20.0003C10.226 19.267 9.62602 18.667 8.89268 18.667Z",
      fill: "#00FFFF"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.7735 13.333H14.2135C12.7469 13.333 11.5469 14.533 11.5469 15.9997V27.9997C11.5469 28.733 12.1469 29.333 12.8802 29.333H19.1069C19.8402 29.333 20.4402 28.733 20.4402 27.9997V15.9997C20.4402 14.533 19.2535 13.333 17.7735 13.333Z",
      fill: "#00FFFF"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M26.6668 22.667H23.1068C22.3734 22.667 21.7734 23.267 21.7734 24.0003V28.0003C21.7734 28.7337 22.3734 29.3337 23.1068 29.3337H28.0001C28.7334 29.3337 29.3334 28.7337 29.3334 28.0003V25.3337C29.3334 23.867 28.1334 22.667 26.6668 22.667Z",
      fill: "#00FFFF"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.0126 6.46697C20.4259 6.05363 20.5859 5.5603 20.4526 5.13363C20.3193 4.70697 19.9059 4.4003 19.3193 4.30697L18.0393 4.09363C17.9859 4.09363 17.8659 4.0003 17.8393 3.94697L17.1326 2.53363C16.5993 1.45363 15.3859 1.45363 14.8526 2.53363L14.1459 3.94697C14.1326 4.0003 14.0126 4.09363 13.9593 4.09363L12.6793 4.30697C12.0926 4.4003 11.6926 4.70697 11.5459 5.13363C11.4126 5.5603 11.5726 6.05363 11.9859 6.46697L12.9726 7.46697C13.0259 7.50697 13.0659 7.66697 13.0526 7.7203L12.7726 8.94697C12.5593 9.86697 12.9059 10.2803 13.1326 10.4403C13.3593 10.6003 13.8526 10.8136 14.6659 10.3336L15.8659 9.62697C15.9193 9.58697 16.0926 9.58697 16.1459 9.62697L17.3326 10.3336C17.7059 10.5603 18.0126 10.627 18.2526 10.627C18.5326 10.627 18.7326 10.5203 18.8526 10.4403C19.0793 10.2803 19.4259 9.86697 19.2126 8.94697L18.9326 7.7203C18.9193 7.65363 18.9593 7.50697 19.0126 7.46697L20.0126 6.46697Z",
      fill: "#00FFFF"
    }
  )
);

export { CryptoFeature };
//# sourceMappingURL=CryptoFeature.js.map
